export default __webpack_public_path__ + "static/media/dialogos_banner.5b25710f.jpg";